/**
 * The history Object is created  as an independent Object instead of
 * using BrowserRouter
 * The Object can be passed as a Prop to  Router to initialize React Router history
 * <Router history={customHistory}
 *
 * Advantage of creating custom History as a global Object is, it can be called in any file
 * which requires/modifies browser url or Params
 *
 * As of July 26, 2019 its been used to modify filter params
 *
 * CODE SMELL - CODE SMELL
 * The history package is downloaded as part of react-router dependencies.
 * The moment react-router takes out history from its deps, this whole thing needs to be revisited
 *
 * 'history' is not downloaded as a dep to maintain consistency with react-router
 *  */

// eslint-disable-next-line node/no-extraneous-import
import { createBrowserHistory } from 'history'

let customHistory

if (typeof window !== 'undefined') {
  customHistory = createBrowserHistory()
}

export { customHistory }
